module.exports = __webpack_public_path__ + "static/images/styles/images/icons/industrial-resource-small.c25528f8.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/icons/industrial-resource-small.png
// module id = 3638
// module chunks = 11